import { render } from "./LoginForgetPasswordModel.vue?vue&type=template&id=ae979454"
import script from "./LoginForgetPasswordModel.vue?vue&type=script&lang=js"
export * from "./LoginForgetPasswordModel.vue?vue&type=script&lang=js"

import "./LoginForgetPasswordModel.vue?vue&type=style&index=0&id=ae979454&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__